/**
 * Incremental SSE parser for `text/event-stream` bodies.
 * Feeds decoded text chunks and yields complete events (`event` + JSON `data`).
 */
export class SseParser {
  #buffer = '';

  push(chunk: string): Array<{ event: string; data: string }> {
    this.#buffer += chunk;
    const events: Array<{ event: string; data: string }> = [];

    let separatorIndex = this.#buffer.indexOf('\n\n');

    while (separatorIndex !== -1) {
      const rawEvent = this.#buffer.slice(0, separatorIndex);
      this.#buffer = this.#buffer.slice(separatorIndex + 2);
      const parsed = this.#parseEventBlock(rawEvent);

      if (parsed) {
        events.push(parsed);
      }

      separatorIndex = this.#buffer.indexOf('\n\n');
    }

    return events;
  }

  #parseEventBlock(rawEvent: string): { event: string; data: string } | null {
    let eventName = 'message';
    const dataLines: string[] = [];

    for (const line of rawEvent.split('\n')) {
      if (line.startsWith('event:')) {
        eventName = line.slice('event:'.length).trim();
      } else if (line.startsWith('data:')) {
        dataLines.push(line.slice('data:'.length).trim());
      }
    }

    if (dataLines.length === 0) {
      return null;
    }

    return { event: eventName, data: dataLines.join('\n') };
  }
}
